import React from 'react';
import styles from './Comments.module.scss';

import { NoDataTableRow, TableHeadComponent, TableWrapper } from 'components/SummaryComponents';
import { StyledTableCell, StyledTableRow } from 'components/StyledComponents';

import { Table, TableBody } from '@material-ui/core';

import { dateTimeFormat, formatDate, getUserFullName } from 'helpers/AppHelpers';

const tableConfig = [
  { label: 'Comments', isSortable: false },
  { label: 'Date', isSortable: false },
  { label: 'Created by', isSortable: false }
];

export function Comments({ data }) {
  return (
    <TableWrapper>
      <Table>
        <TableHeadComponent config={tableConfig} />
        <TableBody>
          {data?.length ? (
            data.map(({ id, description, createdAtUtc, createdByUser }) => (
              <StyledTableRow key={id} className={styles.table_row}>
                <StyledTableCell className={styles.commentCell}>
                  {description || ''}
                </StyledTableCell>
                <StyledTableCell className={styles.dateCell}>
                  {createdAtUtc ? formatDate(createdAtUtc, dateTimeFormat) : ''}
                </StyledTableCell>
                <StyledTableCell className={styles.createdCell}>
                  {getUserFullName(createdByUser)}
                </StyledTableCell>
              </StyledTableRow>
            ))
          ) : (
            <NoDataTableRow />
          )}
        </TableBody>
      </Table>
    </TableWrapper>
  );
}
